import style_alertdialog_input from "./common/style_alertdialog_input.json"
import style_alertdialog_list_multi_radio from "./common/style_alertdialog_list_multi_radio.json"
import style_alertdialog_round_button from "./common/style_alertdialog_round_button.json"
import style_alertdialog_simple from "./common/style_alertdialog_simple.json"
import style_alertdialog_simple_detail_text from "./common/style_alertdialog_simple_detail_text.json"
import style_alertdialog_simple_single_button from "./common/style_alertdialog_simple_single_button.json"
import style_avatar_big from "./common/style_avatar_big.json"
import style_avatar_large from "./common/style_avatar_large.json"
import style_avatar_little from "./common/style_avatar_little.json"
import style_avatar_medium from "./common/style_avatar_medium.json"
import style_avatar_small from "./common/style_avatar_small.json"
import style_badge_normal from "./common/style_badge_normal.json"
import style_badge_normalwithborder from "./common/style_badge_normalwithborder.json"
import style_badge_number from "./common/style_badge_number.json"
import style_badge_small from "./common/style_badge_small.json"
import style_bubble_table_bottom from "./common/style_bubble_table_bottom.json"
import style_bubble_table_bottom_horizontal from "./common/style_bubble_table_bottom_horizontal.json"
import style_bubble_table_bottom_horizontal_icon from "./common/style_bubble_table_bottom_horizontal_icon.json"
import style_bubble_table_top from "./common/style_bubble_table_top.json"
import style_bubble_text_black_bottom from "./common/style_bubble_text_black_bottom.json"
import style_bubble_text_black_left from "./common/style_bubble_text_black_left.json"
import style_bubble_text_black_right from "./common/style_bubble_text_black_right.json"
import style_bubble_text_black_top from "./common/style_bubble_text_black_top.json"
import style_bubble_text_default_bottom from "./common/style_bubble_text_default_bottom.json"
import style_bubble_text_default_left from "./common/style_bubble_text_default_left.json"
import style_bubble_text_default_right from "./common/style_bubble_text_default_right.json"
import style_bubble_text_default_top from "./common/style_bubble_text_default_top.json"
import style_bubble_text_white_bottom from "./common/style_bubble_text_white_bottom.json"
import style_bubble_text_white_left from "./common/style_bubble_text_white_left.json"
import style_bubble_text_white_right from "./common/style_bubble_text_white_right.json"
import style_bubble_text_white_top from "./common/style_bubble_text_white_top.json"
import style_button_big_grey_border from "./common/style_button_big_grey_border.json"
import style_button_big_main_bg from "./common/style_button_big_main_bg.json"
import style_button_big_main_border from "./common/style_button_big_main_border.json"
import style_button_big_orange_bg from "./common/style_button_big_orange_bg.json"
import style_button_big_orange_border from "./common/style_button_big_orange_border.json"
import style_button_big_white_bg from "./common/style_button_big_white_bg.json"
import style_button_big_white_border from "./common/style_button_big_white_border.json"
import style_button_medium_grey_border from "./common/style_button_medium_grey_border.json"
import style_button_medium_main_bg from "./common/style_button_medium_main_bg.json"
import style_button_medium_main_border from "./common/style_button_medium_main_border.json"
import style_button_medium_orange_bg from "./common/style_button_medium_orange_bg.json"
import style_button_medium_orange_border from "./common/style_button_medium_orange_border.json"
import style_button_medium_white_bg from "./common/style_button_medium_white_bg.json"
import style_button_medium_white_border from "./common/style_button_medium_white_border.json"
import style_button_small_grey_border from "./common/style_button_small_grey_border.json"
import style_button_small_orange_bg from "./common/style_button_small_orange_bg.json"
import style_button_small_orange_border from "./common/style_button_small_orange_border.json"
import style_button_small_white_bg from "./common/style_button_small_white_bg.json"
import style_button_small_white_border from "./common/style_button_small_white_border.json"
import style_button_super_grey_border from "./common/style_button_super_grey_border.json"
import style_button_super_main_bg from "./common/style_button_super_main_bg.json"
import style_button_super_main_border from "./common/style_button_super_main_border.json"
import style_button_super_orange_bg from "./common/style_button_super_orange_bg.json"
import style_button_super_orange_border from "./common/style_button_super_orange_border.json"
import style_button_super_white_bg from "./common/style_button_super_white_bg.json"
import style_button_tiny_grey_border from "./common/style_button_tiny_grey_border.json"
import style_button_tiny_main_bg from "./common/style_button_tiny_main_bg.json"
import style_button_tiny_main_border from "./common/style_button_tiny_main_border.json"
import style_button_tiny_orange_bg from "./common/style_button_tiny_orange_bg.json"
import style_button_tiny_orange_border from "./common/style_button_tiny_orange_border.json"
import style_button_tiny_white_bg from "./common/style_button_tiny_white_bg.json"
import style_datepicker_area from "./common/style_datepicker_area.json"
import style_datepicker_degree from "./common/style_datepicker_degree.json"
import style_datepicker_time from "./common/style_datepicker_time.json"
import style_emptystate_default from "./common/style_emptystate_default.json"
import style_gradient_button_medium_orange_bg from "./common/style_gradient_button_medium_orange_bg.json"
import style_grid_normal from "./common/style_grid_normal.json"
import style_icon_button_small_orange_bg from "./common/style_icon_button_small_orange_bg.json"
import style_letterindex_default from "./common/style_letterindex_default.json"
import style_loading_gradient from "./common/style_loading_gradient.json"
import style_loading_gray from "./common/style_loading_gray.json"
import style_loading_gray_dark from "./common/style_loading_gray_dark.json"
import style_loading_gray_light from "./common/style_loading_gray_light.json"
import style_loading_white from "./common/style_loading_white.json"
import style_marquise_pageindicator_orange from "./common/style_marquise_pageindicator_orange.json"
import style_marquise_pageindicator_white from "./common/style_marquise_pageindicator_white.json"
import style_pageindicator_small_orange from "./common/style_pageindicator_small_orange.json"
import style_pageindicator_small_white from "./common/style_pageindicator_small_white.json"
import style_seekbar_normal from "./common/style_seekbar_normal.json"
import style_sheet_share from "./common/style_sheet_share.json"
import style_sheet_table from "./common/style_sheet_table.json"
import style_sheet_title_table from "./common/style_sheet_title_table.json"
import style_switch_button_normal from "./common/style_switch_button_normal.json"
import style_tab_home_black_indicator from "./common/style_tab_home_black_indicator.json"
import style_tab_home_black_indicator_no_underline from "./common/style_tab_home_black_indicator_no_underline.json"
import style_tab_primary_bottom_panel_equal from "./common/style_tab_primary_bottom_panel_equal.json"
import style_tab_primary_bottom_panel_left from "./common/style_tab_primary_bottom_panel_left.json"
import style_tab_primary_equal from "./common/style_tab_primary_equal.json"
import style_tab_primary_left from "./common/style_tab_primary_left.json"
import style_tab_primary_navigation from "./common/style_tab_primary_navigation.json"
import style_tab_secondary_equal from "./common/style_tab_secondary_equal.json"
import style_tab_secondary_left from "./common/style_tab_secondary_left.json"
import style_tab_secondary_orange_indicator from "./common/style_tab_secondary_orange_indicator.json"
import style_tab_secondary_orange_indicator_no_underline from "./common/style_tab_secondary_orange_indicator_no_underline.json"
import style_tab_small_white_indicator from "./common/style_tab_small_white_indicator.json"
import style_tab_tag_left from "./common/style_tab_tag_left.json"
import style_toast_download from "./common/style_toast_download.json"
import style_toast_failed from "./common/style_toast_failed.json"
import style_toast_success from "./common/style_toast_success.json"
import style_toast_text from "./common/style_toast_text.json"
export default {
"style_alertdialog_input": style_alertdialog_input,
"style_alertdialog_list_multi_radio": style_alertdialog_list_multi_radio,
"style_alertdialog_round_button": style_alertdialog_round_button,
"style_alertdialog_simple": style_alertdialog_simple,
"style_alertdialog_simple_detail_text": style_alertdialog_simple_detail_text,
"style_alertdialog_simple_single_button": style_alertdialog_simple_single_button,
"style_avatar_big": style_avatar_big,
"style_avatar_large": style_avatar_large,
"style_avatar_little": style_avatar_little,
"style_avatar_medium": style_avatar_medium,
"style_avatar_small": style_avatar_small,
"style_badge_normal": style_badge_normal,
"style_badge_normalwithborder": style_badge_normalwithborder,
"style_badge_number": style_badge_number,
"style_badge_small": style_badge_small,
"style_bubble_table_bottom": style_bubble_table_bottom,
"style_bubble_table_bottom_horizontal": style_bubble_table_bottom_horizontal,
"style_bubble_table_bottom_horizontal_icon": style_bubble_table_bottom_horizontal_icon,
"style_bubble_table_top": style_bubble_table_top,
"style_bubble_text_black_bottom": style_bubble_text_black_bottom,
"style_bubble_text_black_left": style_bubble_text_black_left,
"style_bubble_text_black_right": style_bubble_text_black_right,
"style_bubble_text_black_top": style_bubble_text_black_top,
"style_bubble_text_default_bottom": style_bubble_text_default_bottom,
"style_bubble_text_default_left": style_bubble_text_default_left,
"style_bubble_text_default_right": style_bubble_text_default_right,
"style_bubble_text_default_top": style_bubble_text_default_top,
"style_bubble_text_white_bottom": style_bubble_text_white_bottom,
"style_bubble_text_white_left": style_bubble_text_white_left,
"style_bubble_text_white_right": style_bubble_text_white_right,
"style_bubble_text_white_top": style_bubble_text_white_top,
"style_button_big_grey_border": style_button_big_grey_border,
"style_button_big_main_bg": style_button_big_main_bg,
"style_button_big_main_border": style_button_big_main_border,
"style_button_big_orange_bg": style_button_big_orange_bg,
"style_button_big_orange_border": style_button_big_orange_border,
"style_button_big_white_bg": style_button_big_white_bg,
"style_button_big_white_border": style_button_big_white_border,
"style_button_medium_grey_border": style_button_medium_grey_border,
"style_button_medium_main_bg": style_button_medium_main_bg,
"style_button_medium_main_border": style_button_medium_main_border,
"style_button_medium_orange_bg": style_button_medium_orange_bg,
"style_button_medium_orange_border": style_button_medium_orange_border,
"style_button_medium_white_bg": style_button_medium_white_bg,
"style_button_medium_white_border": style_button_medium_white_border,
"style_button_small_grey_border": style_button_small_grey_border,
"style_button_small_orange_bg": style_button_small_orange_bg,
"style_button_small_orange_border": style_button_small_orange_border,
"style_button_small_white_bg": style_button_small_white_bg,
"style_button_small_white_border": style_button_small_white_border,
"style_button_super_grey_border": style_button_super_grey_border,
"style_button_super_main_bg": style_button_super_main_bg,
"style_button_super_main_border": style_button_super_main_border,
"style_button_super_orange_bg": style_button_super_orange_bg,
"style_button_super_orange_border": style_button_super_orange_border,
"style_button_super_white_bg": style_button_super_white_bg,
"style_button_tiny_grey_border": style_button_tiny_grey_border,
"style_button_tiny_main_bg": style_button_tiny_main_bg,
"style_button_tiny_main_border": style_button_tiny_main_border,
"style_button_tiny_orange_bg": style_button_tiny_orange_bg,
"style_button_tiny_orange_border": style_button_tiny_orange_border,
"style_button_tiny_white_bg": style_button_tiny_white_bg,
"style_datepicker_area": style_datepicker_area,
"style_datepicker_degree": style_datepicker_degree,
"style_datepicker_time": style_datepicker_time,
"style_emptystate_default": style_emptystate_default,
"style_gradient_button_medium_orange_bg": style_gradient_button_medium_orange_bg,
"style_grid_normal": style_grid_normal,
"style_icon_button_small_orange_bg": style_icon_button_small_orange_bg,
"style_letterindex_default": style_letterindex_default,
"style_loading_gradient": style_loading_gradient,
"style_loading_gray": style_loading_gray,
"style_loading_gray_dark": style_loading_gray_dark,
"style_loading_gray_light": style_loading_gray_light,
"style_loading_white": style_loading_white,
"style_marquise_pageindicator_orange": style_marquise_pageindicator_orange,
"style_marquise_pageindicator_white": style_marquise_pageindicator_white,
"style_pageindicator_small_orange": style_pageindicator_small_orange,
"style_pageindicator_small_white": style_pageindicator_small_white,
"style_seekbar_normal": style_seekbar_normal,
"style_sheet_share": style_sheet_share,
"style_sheet_table": style_sheet_table,
"style_sheet_title_table": style_sheet_title_table,
"style_switch_button_normal": style_switch_button_normal,
"style_tab_home_black_indicator": style_tab_home_black_indicator,
"style_tab_home_black_indicator_no_underline": style_tab_home_black_indicator_no_underline,
"style_tab_primary_bottom_panel_equal": style_tab_primary_bottom_panel_equal,
"style_tab_primary_bottom_panel_left": style_tab_primary_bottom_panel_left,
"style_tab_primary_equal": style_tab_primary_equal,
"style_tab_primary_left": style_tab_primary_left,
"style_tab_primary_navigation": style_tab_primary_navigation,
"style_tab_secondary_equal": style_tab_secondary_equal,
"style_tab_secondary_left": style_tab_secondary_left,
"style_tab_secondary_orange_indicator": style_tab_secondary_orange_indicator,
"style_tab_secondary_orange_indicator_no_underline": style_tab_secondary_orange_indicator_no_underline,
"style_tab_small_white_indicator": style_tab_small_white_indicator,
"style_tab_tag_left": style_tab_tag_left,
"style_toast_download": style_toast_download,
"style_toast_failed": style_toast_failed,
"style_toast_success": style_toast_success,
"style_toast_text": style_toast_text,}